export default "__VITE_ASSET__BLWJH0BZ__"